import Image from 'next/legacy/image'
import styled from 'styled-components'

import { breakpoints, colors } from '@/styles'
import { PricingButton } from '@/features/Pricing/types'
import { Button as ButtonComponent } from '@/components/button-new'
import { H3, H5, ParagraphSmall } from '@/components/text'

import { Plan, PlanName, Plans } from './pricing-plans'
import recapImage from './images/recap.png'

const PlanGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 160px);
  grid-template-rows: 186px;
  justify-content: flex-end;
  align-items: center;
  grid-gap: 0 48px;
`

const Button = styled(ButtonComponent)`
  width: 100%;
`

const PlanCard = styled.div`
  color: ${colors.grey08};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`

const Price = styled(H3)`
  margin-bottom: 4px;
`

const MonthlyPrice = styled(ParagraphSmall)`
  height: 48px;
  text-align: center;
  color: ${colors.grey32};
  max-width: 148px;
`

const Section = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0 24px;
  @media screen and (max-width: ${breakpoints.tabletLandscape}) {
    display: none;
  }
`

const PlanTitle = styled(H5)`
  margin-bottom: 8px;
`

const ImageContainer = styled.div`
  min-height: 186px;
  max-height: 186px;
  position: relative;
  width: 100%;
  height: 100%;
`

type RecapProps = {
  plans: Plans
  hideButtons?: boolean
  featuredPlan?: PlanName
  getButtonData: (plan: Plan, condensed: boolean) => PricingButton
}

const RecapSection = ({
  plans,
  hideButtons,
  featuredPlan,
  getButtonData
}: RecapProps) => {
  return (
    <Section>
      <ImageContainer>
        <Image
          src={recapImage}
          layout="fill"
          sizes="392px"
          objectFit="contain"
          objectPosition="left center"
          alt=""
          placeholder="blur"
        />
      </ImageContainer>
      <PlanGrid>
        {plans.map(plan => {
          const isFeaturedPlan = plan.value === featuredPlan
          const buttonData = getButtonData(plan, true)
          const disabled = buttonData.disabled
          return (
            <PlanCard key={plan.value}>
              <PlanTitle>{plan.name}</PlanTitle>
              <Price>${plan.price.annual}</Price>
              <MonthlyPrice>{plan.monthText}</MonthlyPrice>
              {!hideButtons && (
                <>
                  {buttonData.onClick ? (
                    <Button
                      id={`${plan.id}-second`}
                      theme={isFeaturedPlan ? 'primary' : 'secondary'}
                      size="small"
                      disabled={disabled}
                      onClick={buttonData.onClick}
                    >
                      {buttonData.text}
                    </Button>
                  ) : (
                    <Button
                      id={`${plan.id}-second`}
                      href={buttonData?.href}
                      theme={isFeaturedPlan ? 'primary' : 'secondary'}
                      size="small"
                      disabled={disabled}
                    >
                      {buttonData.text}
                    </Button>
                  )}
                </>
              )}
            </PlanCard>
          )
        })}
      </PlanGrid>
    </Section>
  )
}

export default RecapSection
